import { render, staticRenderFns } from "./Moon.vue?vue&type=template&id=b356a8d6&"
import script from "./Moon.vue?vue&type=script&lang=js&"
export * from "./Moon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports